import React from "react";

export const FlagComponent = (props) => {
    let flag
    try {
        flag = require("../../../../public/images/" + props.imageName)
    } catch (e) {
        flag = 'unknown.png'
    }
    return (
        flag ? <img
                src={flag}
                alt="Flag" className={"img-fluid"} width={50}/>
            : null
    )
}
